import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// STYLES
import "./ForgotPasswordFlow.scss";

// COMPONENTS
import ForgotPassword from "./ForgotPassword";
import ForgotPasswordCode from "./ForgotPasswordCode";
import ForgotPasswordUpdateVersion from "./ForgotPasswordUpdateVersion";

enum ForgotPasswordFlowStep {
    EnterEmail = "ENTER_EMAIL",
    UpgradeVersion = "UPGRADE_VERSION",
    EnterCode = "ENTER_CODE", // ENTER CODE is now part of this flow - when time refactor names
}

const ForgotPasswordFlow: React.FC = () => {
    const [flowState, setFlowState] = useState<ForgotPasswordFlowStep>(
        ForgotPasswordFlowStep.EnterEmail,
    );

    const [userEmail, setUserEmail] = useState<string>("");

    const navigate = useNavigate();

    return (
        <div className="ForgotPasswordFlow">
            {/* ENTER EMAIL STEP */}
            {flowState === ForgotPasswordFlowStep.EnterEmail ? (
                <ForgotPassword
                    setUserEmail={(email: string) => {
                        setUserEmail(email);
                    }}
                    onCancel={() => {
                        navigate("/login", { replace: true });
                    }}
                    onCodeSendSuccess={(updateRequired: boolean) => {
                        const nextStep = updateRequired
                            ? ForgotPasswordFlowStep.UpgradeVersion
                            : ForgotPasswordFlowStep.EnterCode;
                        setFlowState(nextStep);
                    }}
                    onLegacyUserDetected={() => {
                        setFlowState(ForgotPasswordFlowStep.UpgradeVersion);
                    }}
                />
            ) : (
                <></>
            )}

            {/* OOPS STEP (IF APPLICABLE) */}
            {flowState === ForgotPasswordFlowStep.UpgradeVersion ? (
                <ForgotPasswordUpdateVersion
                    onReturnToSignIn={() => {
                        navigate("/login", { replace: true });
                    }}
                />
            ) : (
                <></>
            )}

            {/* ENTER CODE STEP */}
            {flowState === ForgotPasswordFlowStep.EnterCode ? (
                <ForgotPasswordCode
                    userEmail={userEmail}
                    onPasswordResetSuccess={() => {
                        navigate("/login", { replace: true });
                    }}
                    onCancel={() => {
                        navigate("/login", { replace: true });
                    }}
                />
            ) : (
                <></>
            )}
        </div>
    );
};

export default ForgotPasswordFlow;
